var exports = {
  "iE": "xaee3c4fa--c4fa36--wrapper",
  "i9": "xaee3c4fa--c4fa36--_clickable",
  "P7": "xaee3c4fa--c4fa36--inner-wrapper",
};

module.exports = exports;
